import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonCard, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";

const AllOlympiad: React.FC = () => {

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery"; // Set page title
    }, []);

    return (
        <IonContent>
            <Header />
            <IonCard className='privacy-policy-section'>
                <h1 className='text-center font-50'>Olympiads</h1>
                <section className="olympiad-section">

                    <h2 style={{fontWeight: "bolder"}}>Class One</h2>
                    <div className="olympiad-grid">
                        <div className="olympiad-card imo">
                            <h3>📐 IMO</h3>
                            <p>Math Olympiad practice for Class 1</p>
                            <Link to="/olympiad-classone/imo">Start Now</Link>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>🔬 NSO</h3>
                            <p>Science Olympiad made easy and fun</p>
                            <Link to="/olympiad-classone/nso">Start Now</Link>
                        </div>
                        <div className="olympiad-card ieo">
                            <h3>🗣️ IEO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/olympiad-classone/ieo">Start Now</Link>
                        </div>
                        <div className="olympiad-card igko">
                            <h3>🌍 IGKO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/olympiad-classone/igko">Start Now</Link>
                        </div>
                        <div className="olympiad-card nco">
                            <h3>💻  NCO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/olympiad-classone/nco">Start Now</Link>
                        </div>
                    </div>

                    <h2 className="mt-5" style={{fontWeight: "bolder"}}>Class Two</h2>
                    <div className="olympiad-grid">
                        <div className="olympiad-card imo">
                            <h3>📐 IMO</h3>
                            <p>Math Olympiad practice for Class 2</p>
                            <Link to="/olympiad-classtwo/imo">Start Now</Link>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>🔬 NSO</h3>
                            <p>Science Olympiad made easy and fun</p>
                            <Link to="/olympiad-classtwo/nso">Start Now</Link>
                        </div>
                        <div className="olympiad-card ieo">
                            <h3>🗣️ IEO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/olympiad-classtwo/ieo">Start Now</Link>
                        </div>
                        <div className="olympiad-card igko">
                            <h3>🌍 IGKO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/olympiad-classtwo/igko">Start Now</Link>
                        </div>
                        <div className="olympiad-card nco">
                            <h3>💻 NCO</h3>
                            <p>Build English skills with Olympiad sets</p>
                            <Link to="/olympiad-classtwo/nco">Start Now</Link>
                        </div>
                    </div>
                    <h2 className="mt-5" style={{fontWeight: "bolder"}}>Class Three</h2>
                    <div className="olympiad-grid">
                        <div className="olympiad-card imo">
                            <h3>📐 IMO</h3>
                            <p>Math Olympiad practice for Class 3</p>
                            <Link to="/olympiad-classthree/imo">Start Now</Link>
                        </div>
                        <div className="olympiad-card nso">
                            <h3>🔬 NSO</h3>
                            <p>Science Olympiad made easy and fun</p>
                            <Link to="/olympiad-classthree/nso">Start Now</Link>
                        </div>
                    </div>
                </section>
            </IonCard>
            <Footer />
        </IonContent>
    );
};
export default AllOlympiad;